import { useMutation, useQuery } from '@apollo/client';
import { FlashMessage } from '@bnnvara/flash-message';
import { BaseForm } from '@bnnvara/forms/src/new_components/BaseForm/BaseForm';
import { GridItem } from '@bnnvara/grids';
import { Heading } from '@bnnvara/typography';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';

import { UpdateNotificationSettings } from '../../../api/mutations/notifications.gql';
import { FetchNotificationSettings } from '../../../api/queries/me/notifications.gql';
import { SettingFormFields } from './SettingFormFields';
import * as S from './styled';

export function EditorialNotificationSettings({ UID }) {
  const [message, setMessage] = useState(null);
  const theme = useTheme();
  const query = useQuery(FetchNotificationSettings, {
    variables: {
      UID,
    },
  });
  const [updateNotificationSettings, mutation] = useMutation(
    UpdateNotificationSettings
  );
  const isDisabled = mutation.loading;

  useEffect(() => {
    if (mutation.data?.updateNotificationSettings?.error) {
      setMessage((prev) => {
        return {
          error: true,
          text: 'Er is iets misgegaan bij het wegschrijven van de settings',
          count: prev?.count ? prev.count + 1 : 1,
        };
      });
    }
  }, [mutation.data]);

  function handleSubmit(values) {
    if (isDisabled) {
      return;
    }

    updateNotificationSettings({
      variables: {
        editorialNotificationPerEmail: values.editorialNotificationPerEmail,
        editorialNotificationInterval: values.editorialNotificationInterval,
        UID,
      },
    });

    setMessage((prev) => {
      return {
        error: false,
        text: 'Instellingen gewijzigd',
        count: prev?.count ? prev.count + 1 : 1,
      };
    });
  }

  if (query.loading || query.error) {
    return (
      <GridItem columnStartSm="1" columnEndSm="12">
        {query.loading && <p>De settings worden geladen</p>}
        {query.error && (
          <p>Er is een probleem met het ophalen van de settings</p>
        )}
      </GridItem>
    );
  }

  return (
    <>
      <GridItem columnStartSm="1" columnEndSm="12">
        <Heading element="h2" variant="one">
          Jouw instellingen
        </Heading>
      </GridItem>
      <GridItem columnStartSm="1" columnEndSm="12">
        <Heading element="h3" variant="three">
          Volgen
        </Heading>
      </GridItem>
      <GridItem columnStartSm="1" columnEndSm="12">
        {query.data?.me?.notificationSettings && (
          <S.FormContainer isDisabled={isDisabled}>
            <BaseForm
              id="editorial-notification-settings-form"
              onSubmit={handleSubmit}
            >
              <SettingFormFields
                editorialNotificationPerEmail={
                  query.data.me.notificationSettings
                    .editorialNotificationPerEmail
                }
                editorialNotificationInterval={
                  query.data.me.notificationSettings
                    .editorialNotificationInterval
                }
              />
            </BaseForm>
          </S.FormContainer>
        )}
        {message && (
          <FlashMessage
            key={message.count}
            message={message.text}
            color={message.error ? theme.error.main : theme.success.main}
          />
        )}
      </GridItem>
    </>
  );
}

EditorialNotificationSettings.propTypes = {
  UID: PropTypes.string.isRequired,
};
